module.exports = __webpack_public_path__ + "static/media/logo-wallstreet.59451936.jpg";